import React, { useEffect, useState } from "react";
import { storage } from "../firebaseConfig";
import ImageIcon from "@material-ui/icons/Image";
import CircularProgress from "@material-ui/core/CircularProgress";

export default function Imagen(props) {
  const [link, setLink] = useState("");
  const [cargando, setCargando] = useState(false);

  useEffect(() => {
    traerImg();
  }, [props.docName]);

  let traerImg = () => {
    if (props.folder && props.docName) {
      setCargando(true);
      storage
        .ref()
        .child(`${props.folder}/${props.docName}`)
        .getDownloadURL()
        .then((url) => {
          setLink(url);
          setCargando(false);
        })
        .catch((error) => {
          setCargando(false);

          switch (error.code) {
            case "storage/object-not-found":
              console.log("archivo no existe");
              break;

            case "storage/unauthorized":
              console.log("usuario sin permisos para acceder");
              break;

            case "storage/canceled":
              console.log("usuario canceló la descarga");
              break;

            case "storage/unknown":
              console.log("ocurrió un error inesperado");
              break;
          }
        });
    }
  };

  return cargando ? (
    <div
      style={{
        width: "100%",
        height: "200px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <CircularProgress />
    </div>
  ) : link ? (
    <img src={link} className="img-responsive" alt="" />
  ) : (
    <div style={{ display: "flex", justifyContent: "center" }}>
      <ImageIcon
        style={{ width: "50px", height: "50px", color: "gainsboro" }}
      />
    </div>
  );
}
